<template>
  <v-dialog v-model="showConfirm"
            max-width="400">
    <v-toolbar dark dense
               v-if="messageParams.type !== 'loading'"
               color="primary">
      <v-toolbar-title class="white--text">
        {{ messageParams.title }}
      </v-toolbar-title>
    </v-toolbar>
    <v-card tile>
      <v-card-text v-if="messageParams.type === 'loading'">
        <v-row>
          <v-spacer></v-spacer>
          <v-progress-circular indeterminate
                               :size="70"
                               :width="7"
                               :color="messageParams.progressColor"
          ></v-progress-circular>
          <v-spacer></v-spacer>
        </v-row>
      </v-card-text>
      <v-card-text v-if="messageParams.message">
        <v-row v-html="messageParams.message"
               class="pa-2"
               justify="center">
        </v-row>
      </v-card-text>
      <v-card-text v-if="messageParams.link"
                   @click="handleAccept">
        <v-row justify="center">
          <a target="_blank"
             :href="messageParams.link">{{messageParams.linkText || messageParams.link}}
          </a>
        </v-row>
      </v-card-text>
      <v-card-text v-if="messageParams.confirmTextField">
        <v-row>
          <v-text-field v-model="confirmTextFieldValue"
                        ref="textField"
                        :error="!canAccept"
                        :error-messages="!canAccept ? ['Type ' + messageParams.confirmTextField + ' to confirm' ] : []"
          ></v-text-field>
        </v-row>
      </v-card-text>
      <v-card-text v-if="messageParams.freeTextInput">
        <v-row class="">
          <v-text-field v-model="freeTextInputValue"
                        ref="textField"
                        :error-messages="errorMSG"
                        :change="handleChange(freeTextInputValue)"
          ></v-text-field>
        </v-row>
      </v-card-text>
      <v-card-actions v-if="messageParams.type !== 'loading'">
        <v-spacer></v-spacer>
        <v-btn depressed outlined
               v-if="messageParams.messageType === 'confirm'"
               color="primary"
               :disabled="!!timeLeft"
               @click="handleReject"
        >{{timeLeft ? timeLeft : messageParams.cancelText}}
        </v-btn>
        <v-btn depressed
               :disabled="!canAccept"
               :color="messageParams.confirmColor"
               @click="handleAccept"
        >{{messageParams.confirmText}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Vue from 'vue';

  const defaults = {
    confirmText: 'OK',
    cancelText: 'Cancel',
    confirmColor: 'primary',
    progressColor: 'primary',
    timeout: null,
    messageType: null,
    confirmTextField: null,
    freeTextInput: false, // Require a text input,
    title: null,
    message: null,
  };

  export default {
    name: 'UiModal',
    created() {
      Vue.prototype.$confirm = data => new Promise((resolve, reject) => {
        // If no data is sent, just accept it. This can be used to kill a loading modal.
        if (!data) {
          this.handleAccept();
          return;
        }

        if (data.timeout) {
          let seconds = data.timeout / 1000;
          this.timeLeft = seconds;
          let downloadTimer = setInterval(() => {
            this.timeLeft -= 1;
            if (this.timeLeft <= 0) {
              clearInterval(downloadTimer);
            }
          }, 1000);
        }

        this.setMessageParams(data, 'confirm', resolve, reject);
        console.dir(this.$refs);
        this.$nextTick(() => {
          if (this.$refs.textField) {
            this.$refs.textField.focus();
          }
        });
      });
      Vue.prototype.$alert = data => new Promise((resolve, reject) => {
        if (!data) {
          this.handleAccept();
          return;
        }
        this.setMessageParams(data, 'alert', resolve, reject);
      });
    },

    computed: {
      canAccept() {
        if (this.messageParams.freeTextInput) {
          return !(this.freeTextInputValue === null || this.freeTextInputValue === "");
        } else {
          return this.messageParams.confirmTextField === null || this.confirmTextFieldValue === this.messageParams.confirmTextField;
        }
      },
      canAcceptFreeText() {
        if (this.freeTextInputValue === null || this.freeTextInputValue === "") {
          return true;
        }
      },
    },

    data() {
      return {
        timeLeft: 0,
        confirmTextFieldValue: '',
        freeTextInputValue: null,
        resolveFunc: null,
        rejectFunc: null,
        showConfirm: false,
        messageParams: defaults,
        isInputValid: false,
        errorMSG: 'A Value Is Needed',
      };
    },

    methods: {
      handleChange(text) {
        let input = this.strStartsWithLetter(text);
        if (input === '') input = (this.strMinimumInput(text, 3)) ? input : 'Minimum of 3 Characters Needed';
        this.errorMSG = input;
        this.isInputValid = !(input.includes('Invalid') || input.includes('A Value Is Needed') || input.includes('Name can only begin with a letter A-Z') || input.includes('Minimum of 3 Characters Needed!'));
      },
      setMessageParams(data, type, theResolve, theReject) {
        return new Promise((resolve, reject) => {
          this.messageParams = _.clone(defaults);

          _.merge(this.messageParams, data);

          this.resolveFunc = theResolve;
          this.rejectFunc = theReject;
          this.messageParams.messageType = type;
          this.showConfirm = true;

          resolve();
        });
      },
      clearOldData() {
        this.confirmTextFieldValue = '';
      },
      handleAccept() {
        /**
         * If it's a confirmation text field, check the value
         * @type {boolean}
         */
        if (this.messageParams.confirmTextField && this.confirmTextFieldValue === this.messageParams.confirmTextField || !this.messageParams.confirmTextField && !this.messageParams.freeTextInput) {
          this.clearOldData();
          this.showConfirm = false;
          return this.resolveFunc();
        }

        // If it's free text field, send the value back{
        if (this.messageParams.freeTextInput) {
          this.showConfirm = false;
          console.log(this.freeTextInputValue);
          this.resolveFunc(this.freeTextInputValue);
          return this.clearOldData();
        }
      },
      handleReject() {
        this.clearOldData();
        this.showConfirm = false;
        this.rejectFunc();
      },
    },

  };
</script>

